import { TAppState } from '../../types/appState';
import { EChatRole } from '../../types/userData';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export function currentChatOpponentIdSelector(state: TAppState): number | undefined {
  const currentChat = currentOpenChatSelector(state);

  const { users } = currentChat || {};

  const opponent = users?.find(user => user.chatRole === EChatRole.Opponent);

  return opponent?.userId;
}
